<template>
    <div v-if="!hidden">
        <div v-if="hasFinished && finishAction === 'message'">
            <p v-html="message" class="learnworlds-main-text-normal no-margin-bottom"></p>
        </div>

        <div v-else class="timer learnworlds-align-center" :class="timerStyleClass">
            <div ref="cols" class="lw-cols one-row-sp one-row-sl one-row-tp one-row-tp one-row" :class="alignmentClass">
                <div v-for="unit in filteredUnitsShown" class="col no-padding span_3_of_12-sp span_3_of_12-sl span_3_of_12-tp span_3_of_12-tl span_3_of_12 timer-group learnworlds-align-center">
                    <div class="timer-group-digits">
                        <div class="timer-digit" v-if="isSingleDigit(unit)"> <span class="timer-group-num learnworlds-main-text-huge">0</span> </div><!-- Don't insert whitespace
                     --><div class="timer-digit" v-for="digit in units[unit].value.toString().split('')"> <span class="timer-group-num learnworlds-main-text-huge"> {{ digit }}</span></div>
                    </div>
                    <div class="timer-group-label learnworlds-overline-text">{{ $t('common.' + unit) | capitalize }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TimerComponent from "../../components/pagesbuilder/dynamic-components/TimerComponent"
    import PreviewComponent from "./PreviewComponent"

    export default {
        name: "PreviewTimerComponent",
        mixins: [PreviewComponent, TimerComponent]
    }
</script>